import { useQuery } from '@hooks/reactQuery';

import { getPortalProjectAdmins } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_PROJECTS_ADMINS } from '@constants/queryKeys';

interface IUseQueryProjectAdminsReturned {
	portalProjectsAdmins: TNameTitleValueLabel[];
	isLoadingPortalProjectsAdmins: boolean;
}

export const useQueryPortalProjectsAdmins = (organizationId?: string): IUseQueryProjectAdminsReturned => {
	const {
		data: portalProjectsAdmins,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_PROJECTS_ADMINS, { organizationId }],
		queryFn: extractQueryParams(getPortalProjectAdmins),
		enabled: [organizationId],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalProjectsAdmins: portalProjectsAdmins || [],
		isLoadingPortalProjectsAdmins: isLoading || isFetching,
	};
};
